/* eslint-disable react/prop-types */ // TODO: add props
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';
import styles from './QuestionViewTab.scss';
import { Container } from 'edrolo-style-guide';
import { QuestionInstructions } from 'edrolo/domains/exams';
import {
  DragAndDropQuestion,
  FillInBlankQuestion,
  IllustrationQuestion,
  SingleSelectQuestion,
  MultiSelectQuestion,
  NumberQuestion,
  NumberOnImageQuestion,
  SimpleMathQuestion,
  ShortAnswerChecklistQuestion,
  UnsupportedQuestionType,
  WorkedQuestion,
  WorkedChecklistQuestion,
} from 'edrolo/domains/exams/components/Question/components';

// TODO: de-duplicate w/same function in domains.exams.components.Question?
const getQuestionTypeComponent = (question) => {
  const questionType = question.get('question_type');

  if (questionType === EXAM_QUESTION_TYPES.SINGLE_ANSWER_MULTI_CHOICE) {
    return SingleSelectQuestion;
  }
  if (questionType === EXAM_QUESTION_TYPES.SELECT_MULTI) {
    return MultiSelectQuestion;
  }
  if (questionType === EXAM_QUESTION_TYPES.TEXT_CHECKLIST) {
    return ShortAnswerChecklistQuestion;
  }
  if (questionType === EXAM_QUESTION_TYPES.WORKED) {
    return WorkedQuestion;
  }
  if (questionType === EXAM_QUESTION_TYPES.WORKED_ANNOTATED_IMAGE) {
    return WorkedChecklistQuestion;
  }
  if (questionType === EXAM_QUESTION_TYPES.NUMBER) {
    return NumberQuestion;
  }
  if (questionType === EXAM_QUESTION_TYPES.NUMBER_ON_IMAGE) {
    return NumberOnImageQuestion;
  }
  if (questionType === EXAM_QUESTION_TYPES.SIMPLE_MATH) {
    return SimpleMathQuestion;
  }
  if (questionType === EXAM_QUESTION_TYPES.FILL_IN_BLANK) {
    return FillInBlankQuestion;
  }
  if (questionType === EXAM_QUESTION_TYPES.ILLUSTRATION) {
    return IllustrationQuestion;
  }
  if (questionType === EXAM_QUESTION_TYPES.DRAG_AND_DROP) {
    return DragAndDropQuestion;
  }

  return UnsupportedQuestionType;
};

const QuestionViewTab = ({
  classId,
  question,
  exam,
  onSubmitTeacherAnswer,
  ...restProps
}) => {
  const QuestionTypeComponent = getQuestionTypeComponent(question);

  return (
    <div className={styles.questionSet}>
      <Container>
        <QuestionInstructions question={question} />
        <QuestionTypeComponent
          question={question}
          exam={exam}
          classId={classId}
          onQuestionComplete={() => {
            // do nothing
            // We were linking to the same question url anyway?
          }}
          isLastQuestion
          onSubmitTeacherAnswer={onSubmitTeacherAnswer}
          {...restProps}
        />
      </Container>
    </div>
  );
};

export default QuestionViewTab;
